/* eslint-disable no-param-reassign */
import { displayErrorDetails } from '@brands/Utils/displayError';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CurrentPatientState {
  [userId: number]: string;
}

const initialState: CurrentPatientState = {};

const currentPatientStateSlice = createSlice({
  name: 'currentPatientState',
  initialState,
  reducers: {
    setPatientState: (state, action: PayloadAction<{ userId: number; state: string }>) => {
      const { userId, state: newState } = action.payload;
      if (typeof newState === 'string') {
        state[userId] = newState;
      } else {
        displayErrorDetails('New state must be a string.');
      }
    },
    // Persisted slice: without an explicit reset at sign-out, the last
    // selected location would resurface on the next login.
    clearPatientState: () => initialState,
  },
});

export const { setPatientState, clearPatientState } = currentPatientStateSlice.actions;

export default currentPatientStateSlice.reducer;
